// components/ContactUs.jsx
import React, { useState } from 'react';
import '../style.css';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaPlane, FaHotel, FaCar, FaInstagram, FaFacebook, FaTwitter, FaWhatsapp } from 'react-icons/fa';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    destination: '',
    travelDate: '',
    travelers: '1',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
    setFormData({
      name: '',
      email: '',
      phone: '',
      destination: '',
      travelDate: '',
      travelers: '1',
      message: ''
    });
  };

  const contactInfo = [
    { icon: <FaPhone />, title: 'Phone', info: ['6307291567'], description: '24/7 Customer Support' },
    { icon: <FaEnvelope />, title: 'Email', info: ['vnstoursandtravels9696@gmail.com'], description: 'Response within 24 hours' },
    { icon: <FaMapMarkerAlt />, title: 'Office', info: [' G.T road Mohansarai bypas Rajatalab Varanasi UP-221302 '], description: 'Visit our offices' },
    { icon: <FaClock />, title: 'Working Hours', info: ['Mon-Sat: 9AM-8PM', 'Sunday: 10AM-6PM'], description: 'Emergency support available' }
  ];

  const popularPackages = [
    { icon: <FaPlane />, name: 'International Tours', description: 'Europe, USA, Asia Packages' },
    { icon: <FaHotel />, name: 'Domestic Packages', description: 'Himalayas, Beaches, Heritage' },
    { icon: <FaCar />, name: 'Customized Tours', description: 'Tailor-made itineraries' }
  ];

  return (
    <div className="contact-us-container">
      {/* Hero Section */}
      <div className="contact-hero">
        <div className="hero-overlay">
          <h1>Get in Touch with VNS Tours & Travel</h1>
          <p>Your journey begins with a conversation. Let's plan your perfect getaway!</p>
        </div>
      </div>

      <div className="contact-content">
        {/* Left Column - Contact Info */}
        <div className="contact-info-section">
          <h2>Why Choose VNS Tours?</h2>
          <p className="section-description">
            With over 15 years of experience, we provide exceptional travel experiences 
            with personalized service and 24/7 support.
          </p>

          <div className="contact-info-grid">
            {contactInfo.map((item, index) => (
              <div key={index} className="info-card">
                <div className="info-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                {item.info.map((infoItem, idx) => (
                  <p key={idx} className="info-detail">{infoItem}</p>
                ))}
                <p className="info-description">{item.description}</p>
              </div>
            ))}
          </div>

          {/* Popular Packages */}
          <div className="packages-section">
            <h3>Popular Tour Packages</h3>
            <div className="packages-grid">
              {popularPackages.map((pkg, index) => (
                <div key={index} className="package-card">
                  <div className="package-icon">{pkg.icon}</div>
                  <h4>{pkg.name}</h4>
                  <p>{pkg.description}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Social Media */}
          <div className="social-section">
            <h3>Connect With Us</h3>
            <div className="social-icons">
              <a href="#" className="social-icon facebook"><FaFacebook /></a>
              <a href="#" className="social-icon instagram"><FaInstagram /></a>
              <a href="#" className="social-icon twitter"><FaTwitter /></a>
              <a href="#" className="social-icon whatsapp"><FaWhatsapp /></a>
            </div>
            <p className="social-tag">@VNS_Tours_Travel</p>
          </div>
        </div>

        {/* Right Column - Contact Form */}
        <div className="contact-form-section">
          <div className="form-header">
            <h2>Plan Your Dream Vacation</h2>
            <p>Fill the form below and our travel expert will contact you within 2 hours</p>
          </div>

          {submitted && (
            <div className="success-message">
              Thank you! We'll contact you soon to plan your perfect trip.
            </div>
          )}

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="name">Full Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter your full name"
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Enter your email"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="Enter your phone number"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="destination">Destination Interest</label>
                <select
                  id="destination"
                  name="destination"
                  value={formData.destination}
                  onChange={handleChange}
                >
                  <option value="">Select Destination</option>
                  <option value="international">International Tours</option>
                  <option value="domestic">Domestic Tours</option>
                  <option value="honeymoon">Honeymoon Packages</option>
                  <option value="adventure">Adventure Tours</option>
                  <option value="pilgrimage">Pilgrimage Tours</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="travelers">Number of Travelers</label>
                <select
                  id="travelers"
                  name="travelers"
                  value={formData.travelers}
                  onChange={handleChange}
                >
                  {[1,2,3,4,5,6,7,8,9,10].map(num => (
                    <option key={num} value={num}>{num} {num === 1 ? 'Person' : 'People'}</option>
                  ))}
                  <option value="10+">10+ People</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="travelDate">Tentative Travel Date</label>
              <input
                type="date"
                id="travelDate"
                name="travelDate"
                value={formData.travelDate}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Your Requirements *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="4"
                placeholder="Tell us about your travel preferences, budget, special requirements..."
              ></textarea>
            </div>

            <div className="form-checkbox">
              <input type="checkbox" id="newsletter" defaultChecked />
              <label htmlFor="newsletter">Send me travel deals and promotions</label>
            </div>

            <button type="submit" className="submit-btn">
              Request Call Back
            </button>

            <p className="form-note">
              * Our travel expert will contact you with customized quotes
            </p>
          </form>
        </div>
      </div>

      {/* Emergency Contact Banner */}
      <div className="emergency-banner">
        <div className="emergency-content">
          <FaPhone className="emergency-icon" />
          <div>
            <h3>24/7 Emergency Travel Support</h3>
            <p>Call us anytime: <strong> 6307291567</strong></p>
          </div>
        </div>
        <button className="emergency-btn">Emergency Assistance</button>
      </div>
    </div>
  );
};

export default ContactUs;